export default __webpack_public_path__ + "static/media/sixmonthwithoutbg.7abf8148.png";